module.exports = __webpack_public_path__ + "img/16m001-01.408dec17.png";